const sweetsData = ["Indian Sweets", "Innovative Fusions", "Savouries", "Dry Fruits"];   //change sweetscategory

const blogCategory=['AI', 'Consumer Goods', 'Expert Insights' ,'News']

export { blogCategory, sweetsData, };